export const paymentSummary=`<p><em>Navigation:&nbsp; Payments / Summary</em></p>
<p>This screen will show you, by entity, the status of all your payments.&nbsp; You can see payments which have been approved, recurring payments and payments pending approval.</p>
<p>You can choose the fields you want to display on this screen and the order they are displayed in, by clicking on the 3 dot Menu and selecting Manage columns. Amongst the fields you can opt to display is the Channel field – this field indicates the channel that was used to create the payment:</p>
<ul>
<li>Channel = WEB – when the payment was created via the Gem Connect attended channel</li>
<li>Channel = API – when the payment was created via the Gem API unattended channel</li>
<li>Channel = Swift-Fin – when the payment was created via the Gem SWIFT-FIN unattended channel</li>
<li>Channel = CBD – when the payment was created via the Gem Direct unattended channel</li>
<li>Channel = Banking – when the payment was created by Lloyds (e.g. a recurring payment)</li>
</ul>
<p>Use the advanced search capability if you are looking for a specific payment.&nbsp;</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/16/1.png' /></p>
<p>The first column on the screen is an Action column. Subject to the entitlements you have, you can View, Edit and Delete a payment, by using the icons within the Action column. You can View a payment in all three tabs, but you can only Edit or Delete a Recurring or Pending payment or a future dated Approved payment.</p>
<p>If you want to edit a pending payment for example, click on &ldquo;edit&rdquo; and you will be navigated to the payment input screen.&nbsp; You can then edit the payment and the edited payment will be submitted for approval.&nbsp; If an approver rejects a payment, you can edit the payment to correct it or delete it.&nbsp;</p>
<p>Note: only the person who creates a payment can edit or delete the payment.</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/16/2.png' /></p>
<p><strong>Dates in payment summary</strong></p>
<p>In the Approved payments screen, you can see Date created, Value date and Execution date.</p>
<p>The <strong>Date created</strong> is the date the payment is approved, not the date it was created in Gem Connect.</p>
<p>The <strong>Execution date </strong>is the date the payment will start to be processed; that may also be the value date, depending on the method of payment.</p>
<p>If you make a payment that is <strong>future dated</strong>, Payment Summary displays nothing in the &lsquo;Value Date&rsquo; column because until the payment is processed, the value date is unknown.&nbsp;</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/16/3.png' /></p>
<p>In the Recurring payments screen, you can see the next payment date and the end date. The end date is blank if no date was entered when the recurring payment was set up.</p>

<p><img src='${process.env.PUBLIC_URL}/images/4/16/4.png' /></p>
<p>In the pending payments screen you can see the date created and execution date.</p>
<p>If you are also using API, Lloyds Bank Gem Direct or SWIFT FIN channels you will be able to see certain types of payments initiated through these channels &ndash; see table below for further details.</p>
<table class="table table-bordered">
<tbody>
<tr>
<td valign="top" nowrap="nowrap" width="151">
<p><strong>&nbsp;</strong></p>
<p><strong>Channel of Payment</strong></p>
</td>
<td valign="top" nowrap="nowrap" width="113">
<p><strong>Can I see Approved payments?</strong></p>
</td>
<td valign="top" width="104">
<p><strong>Can I see future dated payments?</strong></p>
</td>
<td valign="top" width="104">
<p><strong>Can I amend Payments?</strong></p>
</td>
<td valign="top" width="101">
<p><strong>Can I delete payments?</strong></p>
</td>
</tr>
<tr>
<td valign="top" nowrap="nowrap" width="151">
<p><strong>Lloyds Bank Gem Connect Initiated Payments</strong></p>
</td>
<td valign="top" nowrap="nowrap" width="113">
<p>Yes</p>
</td>
<td valign="top" width="104">
<p>Yes - All Statuses</p>
</td>
<td valign="top" width="104">
<p>Yes &ndash; subject to payment status</p>
</td>
<td valign="top" width="101">
<p>Yes &ndash; subject to payment status</p>
</td>
</tr>
<tr>
<td valign="top" nowrap="nowrap" width="151">
<p><strong>API/SWIFT-FIN Initiated Payments</strong></p>
</td>
<td valign="top" nowrap="nowrap" width="113">
<p>Yes</p>
</td>
<td valign="top" width="104">
<p>Yes - All Statuses</p>
</td>
<td valign="top" width="104">
<p>No</p>
</td>
<td valign="top" width="101">
<p>Yes &ndash; subject to payment status</p>
</td>
</tr>
<tr>
<td valign="top" nowrap="nowrap" width="151">
<p><strong>Lloyds Bank Gem Direct Initiated Payments</strong></p>
</td>
<td valign="top" nowrap="nowrap" width="113">
<p>Yes</p>
</td>
<td valign="top" width="104">
<p>No</p>
</td>
<td valign="top" width="104">
<p>No</p>
</td>
<td valign="top" width="101">
<p>No</p>
</td>
</tr>
</tbody>
</table>
<p>Key points to note:</p>
<ul>
<li>API/Swift-FIN Payments are displayed for &ldquo;view&rdquo; and they can also be cancelled depending on payment status, including future dated payments.&nbsp; Edit payment is not allowed.</li>
<li>When a Lloyds Bank Gem Connect initiated payment, that has been approved, &nbsp;is edited:</li>
<ul><p>&ndash;&nbsp; The system will CANCEL and ADD a new payment when a user edits any payment.</p>
<p>&ndash;&nbsp; After a successful edit, the payment summary screen will display 2 payments:</p>

<ul><ol>
<li>The initial payment with Cancelled status</li>
<li>The new edited payment with the actual payment status</li>
</ol>

</ul>
</ul>

</ul>

<p>Additional functionality:</p>
<ul>
<li>Payment information can be exported in PDF, Excel and CSV formats.</li>
<li>Users can choose to print payments information.</li>
<li>Users can also choose to manage columns displayed for each view and save these settings.</li>
</ul>
<p>&nbsp;</p>
<p><strong>Advanced search</strong></p>
<p>You can use the advanced search capability if you are looking for a specific payment. For example, on Approved payments, you can search by payment type, debit account, debit or credit amount or beneficiary name.</p>
<p>When searching for a beneficiary, you can enter up to a maximum of 35 characters into the ‘Beneficiary name’ field. This field isn’t case sensitive, and you don’t need to update any other search criteria, you can just press ‘Search’.</p>
<p>Once you’ve entered your search details and pressed ‘Search’ the Advanced search pop up window will close, and you’ll now be able to see approved payments which match the search criteria you entered.</p>
<p>&nbsp;</p>
<p><strong>Audit Pending Payments</strong></p>
<p>Switching on this entitlement gives you permission to view all the pending payments for that entity and its descendants, but without giving access to edit or approve those payments.&nbsp; You will also need entitlement to the payment type and account to be able to view pending payments.</p>
<p>For example, if you have permission to all the accounts and to manage Faster Payments and CHAPS, you can view all the pending Faster Payments and CHAPS made on any account but you will not be able to view other payment types.</p>
<p>The &ldquo;Audit pending payments&rdquo; entitlement is a feature entitlement in Payments &amp; transfers.</p>
<p><em>Navigation:  Admin / User role profiles</em></p>
<p><img src='${process.env.PUBLIC_URL}/images/4/16/5.png' /></p>
<p>&nbsp;</p>
<p>To search for pending payments, navigate to Payment Summary, click on the Pending payments tab and use the advanced search function.  Click on “View all payments in progress for business” and you will see a display of all the payments that have not been approved.  That will include payments waiting to be approved and those which have been rejected by the approver.</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/16/6.png' /></p>
<p>In the actions column, on the left hand side of the screen, you will only have &ldquo;view&rdquo; access.&nbsp; So you can look at pending payments but not edit or delete them.</p>
<p>Note: only the payment creator will be able to edit and delete pending payments.</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/16/7.png' /></p>
<p><strong>Payment Summary Statuses</strong></p>
<p>To check the status of a payment, look in Payment Summary in the Approved Payments tab.  Gem Connect displays a transaction status and also an ISO status.  </p>
<p><img src='${process.env.PUBLIC_URL}/images/4/16/8.png' /></p>
<p>This is a list of the ISO statuses you may see and their description:</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/16/9.png' /></p>
<p>Payment Summary will show payments initiated in all channels: Gem Direct, API, Gem Connect and SWIFT GTX.&nbsp;</p>
<p>The PI number (PI#) is displayed in Payment Summary, Approved Payments tab.&nbsp; This enables you to track what has happened to a payment you have submitted.&nbsp; Every payment is assigned a unique PI# when the bank processes your payment.&nbsp; There are circumstances where payments are linked and you can use the PI# to trace and link them.</p>
<ol>
<li>If you submit a multi credit payment and ask the bank to process the batch as a separate payment for each beneficiary,&nbsp; the bank will create one new payment for each credit.&nbsp; The original payment will have a unique PI#, as will each new payment created.</li>
<li>If you submit a payment and we change the method of payment to follow payment preferences to enable a payment to be processed, both the original payment and the new payment will have unique PI#s.&nbsp;</li>
</ol>
<p>&nbsp;</p>
<p>In both scenarios, the original payment you submitted will have a PI#, the subsequent PI flag will be set to &ldquo;Y&rdquo; to show, yes, there are subsequent payment(s), each subsequent payment will have a unique PI# and the subsequent payments will include the original batch payment PI# as a previous PI#.&nbsp; This is an example of what that may look like in Payment Summary.</p>
<p>In the image below, a batch payment was submitted and assigned PI# 400106941513.&nbsp; The batch was split in to 3 separate payments, one for each credit amount in the batch payment.&nbsp; The 3 new payments had a unique PI# assigned 400106941514, 400106941515 and 400106941516.&nbsp; They also have the original PI# 400106941513 assigned as a previous PI#.</p>
<p>There is no subsequent PI#, the status is &ldquo;completed&rdquo; and the ISO status is ACSC which tells us the individual payments were all made successfully and none were rejected or changed in any way, as per customer payment preferences.</p>
<p>&nbsp;</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/16/10.png' /></p>
<p>When you look at the 4 payments together, the original payment has a status of “split” because the batch was split in to multiple payments. It has an ISO status of ACSC which tells you all the subsequent payments completed successfully.  The subsequent payment flag is set to “Y” and the new payments display the original PI# as the previous PI#.</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/16/11.png' /></p>
<p>You can use the advanced search function in Payment Summary to search for PI#s to help you find payments and link together connected payments.</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/16/12.png' /></p>
<p>In the detailed view window in Payment Summary, the “Transaction message” field will display a description of the final status of the payment.  That will include descriptions when a payment is processed successfully (as in the example below) and if a payment is rejected, the reason for the rejection.</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/16/13.png' /></p>
<p>It is recommended that you use the manage columns function in Payment Summary to place the following fields next to each other, so you can understand the status of your payments:</p>
<ul>
<li>Status</li>
<li>Iso status</li>
<li>PI number</li>
<li>Subsequent payment</li>
<li>Subsequent PI#</li>
<li>Previous PI#</li>
</ul>
<p>&nbsp;</p>
<p>As the following tables demonstrate, you should look at all of these fields to understand the status of the payment.</p>
<p>The main section of this table shows the data displayed in Payment Summary for a payment initiated in Gem Connect. Payment number 3 was rejected during processing and a new METHOD OF PAYMENT was created due to payment preferences set up.&nbsp; The original payment with PI# nnnnn3 was rejected.&nbsp; It shows a status of &ldquo;rejected&rdquo; and an ISO status of &ldquo;ACSC&rdquo;.&nbsp; The subsequent payment flag is ticked and there is a subsequent PI# nnnnn4.&nbsp; The ISO status is ACSC because the subsequent payment (PI# nnnnn4) was completed successfully.&nbsp; So you can see the original payment was rejected, a subsequent payment was created and that was successful.&nbsp; If the subsequent payment was rejected too, PI# nnnnn3 would display a status of &ldquo;rejected&rdquo; and an ISO status of &ldquo;RJCT&rdquo;.&nbsp;&nbsp; When a subsequent payment is created, the original payment displays the ISO status of the subsequent payment.</p>
<p>Payments initiated in API or CBD can be seen in Gem Connect but note that their statuses can be different to a Gem Connect initiated payment.&nbsp; This is because if a payment initiated in Gem Connect needs to be changed for processing, the original payment is rejected and a new payment is created.&nbsp; An API or CBD initiated payment is changed, rather than rejected and a new payment created,&nbsp; so you will receive an ACWC ISO status followed by ACSC if the changed payment is successful.&nbsp; Gem Connect only displays the final status of all payments, regardless of where they are initiated.&nbsp; Note that not all scenarios apply to API and CBD payments.</p>
<p>This table shows you statuses that will be displayed for different scenarios, when there is a Preferred METHOD OF PAYMENT preference set up.</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/16/14.png' /></p>
<p>This table shows you payment statuses that will be displayed if we are unable to process the payment you submitted and you have created an alternative method of payment and/or date change payment preference.</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/16/15.png' /></p>
<p><strong>Swift GPI Tracker</strong></p>
<p>The Approved payments tab on the payments summary screen, displays payments which have been approved.</p>
<p>A user should have the following user role profile entitlements in Gem Connect to be able to view the GPI tracker:</p>
<ul>
<li>entitled to GPI Tracker</li>
<li>entitled to access the debit accounts used to make international payments</li>
<li>entitled to see the payments summary screen</li>
</ul>
<p>Subject to the entitlements you have, approved outbound international payments where the payment status is ‘Completed’, will display the UETR (Unique End to end Transaction Reference) as a link.&nbsp;&nbsp;<strong>Please note</strong> ‘Completed’ in this instance means the payment has been sent to Swift for onward processing.</p>
<p>You can use this link to track international payments made via the Gem channels (Gem Connect, API, Commercial Banking Direct and SWIFT FIN).&nbsp;&nbsp;<strong>Please note</strong>, to display Commercial Banking Direct payments, you’ll need to use ‘Advanced search’ and select CBD from the list of Channels to ensure they’re included.</p>
<p>If it’s not already visible, you can choose to display the UETR field on the screen by clicking on the 3-dot menu and selecting ‘Manage columns’.</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/16/16.png' /></p>
<p>If an international payment has a ‘Completed’ status and there’s a UETR, but it’s not showing as a link, please check user permissions to ensure you have the correct entitlements.</p>
<p>Clicking on the UETR link will take you to a new page, the GPI Tracker – Payment events summary, where you’ll find more detail for that specific international payment.</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/16/17.png' /></p>
<p>You’ll see the UETR on the top left and the following other fields:</p>
<ul>
<li>Sender ack.time - this is the time the sender acknowledged receipt of the payment</li>
<li>Last update - the date and time the event was last updated</li>
<li>Message identification - the type of Swift message used to communicate between financial institutions</li>
<li>From - the BIC of the entity sending the funds</li>
<li>To - the BIC of the entity the funds are being sent to</li>
<li>Instruction identification - as part of an international payments journey, funds will pass through other banks. As this happens, other institutions may allocate the payment a different reference; the UETR however, will remain unchanged</li>
<li>Transaction status - the status of the transaction</li>
<li>Reject return reason code - if a payment is rejected, it’s given a code which you’ll find here</li>
<li>Reject return reason description - rejected payments also have a reason description for additional clarity</li>
</ul>
<p>The default display on this page is for the first event in the process to be displayed at the top of the page (this is determined by the column ‘Sender ack. time’ i.e. Sender acknowledgement time’).&nbsp;&nbsp;Clicking on the arrow can change the order from ascending Sender ack. time (arrow pointing up) to descending Sender ack. time (arrow pointing down).</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/16/18.png' /></p>
<p>Selecting the ‘View’ icon against a Payment event opens a new window ‘GPI Tracker – Payment event details’.&nbsp;&nbsp;Here you’ll see more detailed information, for that specific payment event, which will all be read only.</p>
<p><img src='${process.env.PUBLIC_URL}/images/4/16/19.png' /></p>
<p>Clicking ‘Done’ will close the event detail window and you’ll be returned to the GPI Tracker – Payment events summary’ page for the selected UETR.</p>
<p>From the GPI Tracker – Payment events summary page, you can click ‘Cancel’ and you’ll return to the Approved payments tab, within the Payments summary screen.</p>
<p>A list of Transaction status codes and their descriptions can be found below.&nbsp;&nbsp;&nbsp;You’ll find these referenced in both the GPI Tracker payment events summary page and also in the Payment event details page.</p>
<table class="table table-bordered">
<thead>
<tr style='background-color:#000; color:#fff;text-align:center;'>
<th style='width : 12%;border:1px solid #000;'>Transaction status code</th>
<th style='border:1px solid #000;vertical-align:middle;'>Description</th>
</tr>
</thead>
<tbody>
<tr>
<td style='border:1px solid #000;text-align:center;vertical-align:middle;'>ACCC</td>
<td style='border:1px solid #000;'>Settlement on the creditor's account has been completed.</td>
</tr>
<tr>
<td style='border:1px solid #000;text-align:center;vertical-align:middle;'>ACSP</td>
<td style='border:1px solid #000;'>All preceding checks such as technical validation and customer profile were successful and therefore the payment initiation has been accepted for execution.</td>
</tr>
<tr>
<td style='border:1px solid #000;text-align:center;vertical-align:middle;'>RJCT</td>
<td style='border:1px solid #000;'>Payment initiation or individual transaction included in the payment initiation has been rejected.</td>
</tr>
</tbody>
</table>
<p>A list of Transaction status reasons and their descriptions can be found below.</p>
<table class="table table-bordered">
<thead>
<tr style='background-color:#000; color:#fff;text-align:center;'>
<th style='width : 12%;border:1px solid #000;'>Transaction status reason</th>
<th style='border:1px solid #000;vertical-align:middle;'>Description</th>
</tr>
</thead>
<tbody>
<tr>
<td style='border:1px solid #000;text-align:center;vertical-align:middle;'>G000</td>
<td style='border:1px solid #000;'>The Status Originator transferred the Credit Transfer to the next Agent or to a Market Infrastructure maintaining the transaction’s service obligations.</td>
</tr>
<tr>
<td style='border:1px solid #000;text-align:center;vertical-align:middle;'>G001</td>
<td style='border:1px solid #000;'>The Status Originator transferred the Credit Transfer to the next Agent or to a Market Infrastructure where the transaction’s service obligations may no longer be guaranteed.</td>
</tr>
<tr>
<td style='border:1px solid #000;text-align:center;vertical-align:middle;'>G002</td>
<td style='border:1px solid #000;'>The transaction processing cannot be completed the same day.</td>
</tr>
<tr>
<td style='border:1px solid #000;text-align:center;vertical-align:middle;'>G003</td>
<td style='border:1px solid #000;'>In an FI-to-FI Customer Credit Transfer: Credit to creditor's account is pending receipt of required documents. The Status Originator has requested creditor to provide additional documentation.</td>
</tr>
<tr>
<td style='border:1px solid #000;text-align:center;vertical-align:middle;'>G004</td>
<td style='border:1px solid #000;'>Credit to the creditor's account is pending as status Originator is waiting for funds provided via a cover.</td>
</tr>
<tr>
<td style='border:1px solid #000;text-align:center;vertical-align:middle;'>G005</td>
<td style='border:1px solid #000;'>Credit Transfer has been delivered to creditor agent with transaction’s service obligations maintained.</td>
</tr>
<tr>
<td style='border:1px solid #000;text-align:center;vertical-align:middle;'>G006</td>
<td style='border:1px solid #000;'>Credit Transfer has been delivered to creditor agent where the transaction’s service obligations were no longer maintained.</td>
</tr>
</tbody>
</table>
`;



// WEBPACK FOOTER //
// ./src/components/content/payments/16-paymentSummary.ts